const DataDeviceType = {
  PPC: 'ppc',
};
export default DataDeviceType;
